import React from "react";

import Box from "./Box";
import ProductImageSlider from "./ProductImageSlider";
import ProductSpin from "./ProductSpin";
import PropTypes from "prop-types";

function ProductImagesMobile({ images, productSpinImages, brandImages }) {
  return (
    <Box display={["block", null, "none", null]} my={33}>
      <ProductImageSlider images={images} brandImages={brandImages} />
      {productSpinImages.length > 0 && (
        <Box mt={20} px={20}>
          <ProductSpin images={productSpinImages} />
        </Box>
      )}
    </Box>
  );
}

ProductImagesMobile.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  productSpinImages: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  brandImages: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      width: PropTypes.string.isRequired,
      height: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ProductImagesMobile;
